// ComplianceDocument model
export class ComplianceDocument {
  constructor({
    name = '',
    format = null,
    documentStatus = 'PENDING',
    uploadDate = null,
    expirationDate = null,
    path = null,
    entityType = '',
  }) {
    this.name = name;
    this.format = format;
    this.documentStatus = documentStatus;
    this.uploadDate = uploadDate;
    this.expirationDate = expirationDate;
    this.path = path;
    this.entityType = entityType;
  }

  static fromMap(data = {}) {
    return new ComplianceDocument({
      name: data.name || '',
      format: data.format,
      documentStatus: data.documentStatus || 'PENDING',
      uploadDate: data.uploadDate,
      expirationDate: data.expirationDate,
      path: data.path,
      entityType: data.entityType || '',
    });
  }

  get displayName() {
    const nameMap = {
      cedula_de_identidad_delantera: 'Cédula de Identidad (Frontal)',
      cedula_de_identidad_trasera: 'Cédula de Identidad (Trasera)',
      certificado_de_antecedentes: 'Certificado de Antecedentes',
      licencia_conducir_front: 'Licencia de Conducir (Frontal)',
      licencia_conducir_back: 'Licencia de Conducir (Trasera)',
      hoja_vida: 'Hoja de Vida',
    };

    return (
      nameMap[this.name] ||
      this.name
        .replace(/_/g, ' ')
        .split(' ')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    );
  }

  get statusColor() {
    const colorMap = {
      APPROVED: '#4CAF50', // Green
      REJECTED: '#F44336', // Red
      PENDING: '#FFC107', // Yellow
      ERRORS: '#FF5722', // Orange
      EXPIRED: '#9E9E9E', // Grey
      EXPIRING: '#FF9800', // Amber
    };

    return colorMap[this.documentStatus.toUpperCase()] || '#9E9E9E';
  }

  get statusDisplayText() {
    const statusMap = {
      APPROVED: 'Aprobado',
      REJECTED: 'Rechazado',
      PENDING: 'Pendiente',
      ERRORS: 'Con errores',
      EXPIRED: 'Vencido',
      EXPIRING: 'Por vencer',
    };

    return statusMap[this.documentStatus.toUpperCase()] || 'Desconocido';
  }

  shouldShowUploadButton() {
    const status = this.documentStatus.toUpperCase();
    return ['PENDING', 'REJECTED', 'ERRORS', 'EXPIRED', 'EXPIRING'].includes(status);
  }

  getDocumentIcon() {
    if (this.name.includes('cedula')) return 'creditCard';
    if (this.name.includes('licencia')) return 'driveEta';
    if (this.name.includes('antecedentes')) return 'verifiedUser';
    if (this.name.includes('hoja_vida')) return 'description';
    return 'descriptionOutlined';
  }
}

export default ComplianceDocument;
